angular.module('smartorg.r6.mgmts.createPortfolioFrom', []);
require('./create-portfolio-from-existing-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.createPortfolioFrom';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/create-portfolio-from-existing/app/js/plumbing/app.js